import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const upsertDiveEquipmentMutation = graphql(/* GraphQL */ `
  mutation upsertDiveEquipment($input: DiveEquipmentInput!) {
    upsertDiveEquipment(input: $input)
  }
`);

export type DiveEquipmentInput = {
  equipmentId: number;
  userId: string;
  bcd: string;
  wetsuit: string;
  fins: string;
};

const useUpsertDiveEquipment = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Dive equipment sizes saved',
    queryKeys: [profileQueryKeys.diveEquipment(userId)],
  });

  return useMutation({
    mutationFn: async (input: DiveEquipmentInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to upsert dive equipment');
      }
      return graphqlRequest(
        upsertDiveEquipmentMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpsertDiveEquipment;
